import type { SxProps } from '@mui/material';

export const FontNormalSxProps = {
  fontFamily: 'var(--font-text)',
  fontSize: 'var(--font-size-text)',
  lineHeight: 'var(--font-lineheight-text)',
  fontStyle: 'normal',
  fontWeight: 'normal'
} satisfies SxProps;

export function isExtensionAllowed(regExp: RegExp, fileName: string) {
  return regExp.test(fileName);
}
